import React from 'react';
import useGearExpertPopup from '~/hooks/useGearExpertPopup';
import { AnalyticsSource } from '~/services/analytics/AnalyticsInterfaces';
import { fireClickedExpertQuiz } from '~/services/analytics/events/gearExperts';
import { FT_GEAR_EXPERT_CTA_MODE } from '../../constants/featureToggles';

interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  src?: AnalyticsSource;
}

const GearExpertsLink: React.FC<Props> = ({ children, src, ...props }) => {
  const popup = useGearExpertPopup();

  if (FT_GEAR_EXPERT_CTA_MODE === 'zendesk') {
    return (
      // @ts-ignore
      (<button
        {...props}
        onClick={e => {
          popup.open(src);
        }}
      >
        {children}
      </button>)
    );
  }
  return (
    <a
      {...props}
      href="/gear_experts?popup=1"
      onClick={e => {
        props.onClick?.(e);
        fireClickedExpertQuiz(src);
      }}
    >
      {children}
    </a>
  );
};

export default GearExpertsLink;
